import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(
  createStyles({
    borderStyle: {
      borderBottom: '1px solid rgba(0, 0, 0, .125)'
    }
  })
);
